import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Item = styled.div`
  all: unset;
  display: flex;
  margin-bottom: 4px;
  padding: 12px 8px;
  cursor: pointer;

  ${typographyV2.bodyBase}
`;
